<template lang="html">
  <Row type="flex" class="section-navigation" justify="start" style="padding: 0 3vw 32px 3vw; margin-bottom: 28px;">
    <Col span="24">
      <Row type="flex" justify="space-around">
        <PageNavCard direction="next" :title="next.title" :content="next.content" :color="next.color" :route="next.route"></PageNavCard>
        <PageNavCard direction="prev" :title="prev.title" :content="prev.content" :color="prev.color" :route="prev.route"></PageNavCard>
      </Row>
    </Col>
  </Row>
</template>
<script>
import pages from '../services/pages';
import PageNavCard from './PageNavCard';

export default {
  components: { PageNavCard },
  props: { current: { type: String, required: true } },
  data() {
    const vm = this;
    const currentPage = pages[vm.current];
    const nextPage = pages[currentPage.sectionNavigation.next.id];
    const prevPage = pages[currentPage.sectionNavigation.prev.id];
    const next = {
      title: `${currentPage.sectionNavigation.next.title}`,
      color: nextPage.color,
      content: currentPage.sectionNavigation.next.content,
      route: nextPage.route,
    };
    const prev = {
      title: `${currentPage.sectionNavigation.prev.title}`,
      color: prevPage.color,
      content: currentPage.sectionNavigation.prev.content,
      route: prevPage.route,
    };

    return { next, prev, windowWidth: window.innerWidth };
  },
};
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/SectionNavigation.vue